import axios from 'axios'
import router from '../router'
import { Message, MessageBox } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
var baseUrl = '';

if(process.env.NODE_ENV == 'development') {

	//baseUrl = 'http://192.168.20.50:6610/';
	baseUrl = 'http://localhost:6610/';
	//baseUrl = 'https://www.itwaiter.net/';

} else {
	baseUrl = 'https://www.itwaiter.net/';

}

export {
	baseUrl
}
// create an axios instance
const service = axios.create({
	baseURL: baseUrl,
	timeout: 300000, // request timeout  超时时间设为5分钟

})

// request interceptor
service.interceptors.request.use(config => {
	// Do something before request is sent

	if(store.getters.token) {
		config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
	}

	return config
}, error => {
	// Do something with request error

	console.log(error) // for debug
	Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(

	response => {
		/**
		 * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
		 * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
		 */

		if(response.status == 200) {
			const res = response.data;
			if("code" in res) {
				if(res.code !== 0) {

					Message({
						message: res.msg,
						type: 'error',
						duration: 3 * 1000
					});
					return Promise.reject(res)
				}
			}
			return Promise.resolve(res)

		}
	},
	error => {

		let res = error.response;
		if(res) {

			switch(res.status) {
				case 401:

					MessageBox.confirm('会话已超时', '会话提醒', {
						confirmButtonText: '重新登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						router.push({
							path: '/login'
						});

					})

					break;

				case 403:

					Message({
						message: "权限不足",
						type: 'error',
						duration: 5 * 1000
					});

					break;	

				default:

					Message({
						message: error.message,
						type: 'error',
						duration: 5 * 1000
					});
					break;

			}
		} else {
			Message({
				message: "网络连接失败",
				type: 'error',
				duration: 5 * 1000
			});
		}
		return Promise.reject(error)

	})

export default service